var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{class:_vm.downloadAllowed ? '' : 'btn-disabled',attrs:{"classes":"btn btn-green","text":"Download Now","disabled":!_vm.downloadAllowed},nativeOn:{"click":function($event){return _vm.downloadPdf.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }